import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="comp-footer">
      <div>© {new Date().getFullYear()} Aurora Tech</div>
      <div className="muted">Made with care — privacy-first.</div>
    </footer>
  );
}
